import GetClientsRequest from "../requests/GetClientsRequest";
import GetTagsRequest from "../requests/GetTagsRequest";
import GetAllUsersRequest from "../requests/GetAllUsersRequest";
import GetAllMilestones from "../requests/GetAllMilestones";

const TeamChangedActions = (setClients, setTags, setAllUsers, setMilestones) => {
  GetClientsRequest(setClients);
  GetTagsRequest(setTags);
  GetAllUsersRequest(setAllUsers);

  if (setMilestones) {
    GetAllMilestones(setMilestones);
  }
};

export default TeamChangedActions;
